<template>
  <div>

    <el-row>
      <el-col :span="24">
        <Head>
          <template v-slot:title>
            <span style="margin-left:30%;">个人绑定审核</span>
          </template>
        </Head>
      </el-col>
    </el-row>
    <el-row class="row-top" type="flex" justify="center">
      <el-col :span="15">
        <bind-list1 v-if="isShow" @statusFun="getStatus" :genre="genre"></bind-list1>
        <bind-xq1 v-else @statusFun="getStatus" :item="itemData"></bind-xq1>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import Head from '@/components/header/head.vue';
import bindList1 from '@/components/audit/audit_list1.vue';
import bindXq1 from '@/views/audit/bind/bind_particulars1.vue';

export default {
  data() {
    return {
      isShow: true,
      genre: true,
      itemData: []
    }
  },
  methods: {
    getStatus(isShow, itemData) {
      // console.log(isShow,itemData)
      this.isShow = isShow
      if (itemData) {
        this.itemData = itemData
      }
    }
  },
  components: {
    Head,
    bindList1,
    bindXq1

  }
}
</script>
<style lang="less" scoped>

</style>
